import React from 'react';
import { Badge } from '../ui';

/**
 * AttestationStatusCard — pill/badge showing the current attestation lifecycle status.
 * Props:
 *   request  { status, attested_at, ... }
 *   onView   () => void
 */

const STATUS_CONFIG = {
  sent: {
    text: 'Attestation sent — awaiting review',
    badgeVariant: 'primary',
  },
  under_review: {
    text: 'Under review by CPA',
    badgeVariant: 'primary',
  },
  changes_requested: {
    text: 'Changes requested by CPA',
    badgeVariant: 'warning',
  },
  attested: {
    text: 'CPA-attested',
    badgeVariant: 'success',
  },
  declined: {
    text: 'Declined',
    badgeVariant: 'danger',
  },
};

export default function AttestationStatusCard({ request, onView }) {
  const isCancelled =
    request.status === 'declined' && request.declined_reason === 'CANCELLED_BY_DEAL_TEAM';

  const cfg = isCancelled
    ? { text: 'Cancelled', badgeVariant: 'default' }
    : STATUS_CONFIG[request.status] || {
        text: request.status,
        badgeVariant: 'default',
      };

  // Muted tone for a cancelled request (vs. the danger styling of a CPA decline).
  const cancelledStyle = isCancelled ? { backgroundColor: '#F3F4F6', color: '#6B7280' } : {};

  const attestedDate =
    request.status === 'attested' && request.attested_at
      ? new Date(request.attested_at).toLocaleDateString()
      : null;

  const label = attestedDate ? `${cfg.text} (${attestedDate})` : cfg.text;

  return (
    <button
      onClick={onView}
      aria-label={`Attestation status: ${label}. Click to view.`}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        borderRadius: 9999,
        transition: 'opacity 0.15s ease',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.8'; }}
      onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
    >
      <Badge
        variant={cfg.badgeVariant}
        size="sm"
        style={{ textTransform: 'none', letterSpacing: 'normal', fontWeight: 600, fontSize: 12, ...cancelledStyle }}
      >
        {label}
      </Badge>
    </button>
  );
}
